import $http from "../axios";

const actions = {
  getPendingExternalProducts() {
    return new Promise((resolve, reject) => {
      $http
        .get("get-pending-external-products")
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  updateExternalProduct(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-external-products", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

export default {
  actions
};
